"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationRule = void 0;
var ValidationRule;
(function (ValidationRule) {
    ValidationRule[ValidationRule["REQUIRED"] = 0] = "REQUIRED";
    ValidationRule[ValidationRule["NOT_NULL"] = 1] = "NOT_NULL";
    ValidationRule[ValidationRule["NUMERIC"] = 2] = "NUMERIC";
    ValidationRule[ValidationRule["EMAIL"] = 3] = "EMAIL";
    ValidationRule[ValidationRule["NULLABLE"] = 4] = "NULLABLE";
    ValidationRule[ValidationRule["NOT_BLANK"] = 5] = "NOT_BLANK";
})(ValidationRule = exports.ValidationRule || (exports.ValidationRule = {}));
var Validator = /** @class */ (function () {
    function Validator(fieldRules) {
        this.errors = [];
        this.fieldRules = fieldRules;
    }
    Validator.prototype.validate = function (data) {
        // Loop through all the field rules
        for (var _i = 0, _a = this.fieldRules; _i < _a.length; _i++) {
            var fieldRule = _a[_i];
            var errors = [];
            if (fieldRule.rules.some(function (el) { return el == ValidationRule.REQUIRED; }) &&
                !(fieldRule.field in data)) {
                errors.push("'" + fieldRule.field + "' is required");
            }
            if (fieldRule.field in data) {
                var field = fieldRule.field;
                var value = data[field];
                rulesLoop: for (var _b = 0, _c = fieldRule.rules; _b < _c.length; _b++) {
                    var rule = _c[_b];
                    if (rule == ValidationRule.NOT_NULL) {
                        var _d = this.notNullRule(value), pass = _d.pass, gotoNext = _d.gotoNext;
                        if (!pass)
                            errors.push("'" + field + "' must be defined and not null");
                        if (!gotoNext)
                            break rulesLoop;
                    }
                    if (rule == ValidationRule.NOT_BLANK) {
                        var _e = this.notBlankRule(value), pass = _e.pass, gotoNext = _e.gotoNext;
                        if (!pass)
                            errors.push("'" + field + "' cannot be blank");
                        if (!gotoNext)
                            break rulesLoop;
                    }
                    if (rule == ValidationRule.NUMERIC) {
                        var _f = this.numericRule(value), pass = _f.pass, gotoNext = _f.gotoNext;
                        if (!pass)
                            errors.push("'" + field + "' must be numeric");
                        if (!gotoNext)
                            break rulesLoop;
                    }
                    if (rule == ValidationRule.EMAIL) {
                        var _g = this.emailRule(value), pass = _g.pass, gotoNext = _g.gotoNext;
                        if (!pass)
                            errors.push("'" + field + "' must be a valid email address");
                        if (!gotoNext)
                            break rulesLoop;
                    }
                }
            }
            if (errors.length > 0) {
                this.errors.push({
                    field: fieldRule.field,
                    errors: errors,
                });
            }
        }
        return this;
    };
    Validator.prototype.getErrors = function () {
        return this.errors;
    };
    // returns if should go to next rule
    Validator.prototype.notNullRule = function (value) {
        var pass = !!value || value === "";
        if (typeof value == "number" && value === 0)
            pass = true;
        var gotoNext = true;
        return { pass: pass, gotoNext: gotoNext };
    }; //end method notNullRule
    Validator.prototype.numericRule = function (value) {
        var pass = typeof value == "number";
        var gotoNext = true;
        return { pass: pass, gotoNext: gotoNext };
    }; //end method notNullRule
    Validator.prototype.notBlankRule = function (value) {
        var pass = !!value;
        var gotoNext = true;
        return { pass: pass, gotoNext: gotoNext };
    }; //end method notNullRule
    Validator.prototype.emailRule = function (value) {
        var pass = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
        var gotoNext = true;
        return { pass: pass, gotoNext: gotoNext };
    }; //end method notNullRule
    return Validator;
}()); //end class Validator
exports.default = Validator;
